/**
 * List of all supported features.
 */
export const FEATURES = ["source-code-links", "theme-switch"] as const;

/**
 * Key to be used for storing & retrieving features from local storage.
 */
export const FEATURES_KEY = "features";
